import { selectIsRelevantFilterActive } from "~/features/search/redux/searchSelectors";
import { updateRelevantFilterThunk } from "~/features/search/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ICON_MARGIN } from "~/styles/cssConstants";
import { IconButton, Stack, styled, Typography } from "~/common/mui";
import { Switch } from "~/common/components/Switch/Switch";
import { TooltipWithArrow } from "~/common/components/TooltipWithArrow";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface Props {
  className?: string;
}

export const RelevantFilter = (props: Props) => {
  const { t } = useTranslation();

  const isActive = useSelector(selectIsRelevantFilterActive);
  const dispatch = useDispatch();
  const toggle = () => dispatch(updateRelevantFilterThunk(!isActive));

  return (
    <Root className={props.className}>
      <Stack flexDirection={"row"} gap={1} alignItems={"center"}>
        <Typography variant="bodyLarge">{t("page.search.filter.onlyRelevant.title")}</Typography>
        <TooltipWithArrow title={t("page.search.filter.onlyRelevant.infoPopup")} placement="top" arrow>
          <IconButton size="small">
            <InfoOutlinedIcon />
          </IconButton>
        </TooltipWithArrow>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Switch checked={isActive} onChange={toggle} />
        <Typography variant="bodyLarge">
          {isActive ? t("common.toggle.on.text") : t("common.toggle.off.text")}
        </Typography>
      </Stack>
    </Root>
  );
};

const Root = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: ICON_MARGIN,
  padding: "8px 12px",
}));
